import { Link } from "react-router-dom";
import GrantaEarthLogo from "./ui/GrantaEarthLogo";

export default function Footer() {
  return (
    <footer className="bg-deep-green text-white">
      <div className="container-custom py-16 md:py-20">
        <div className="grid gap-8 md:grid-cols-3 lg:gap-12">
          {/* About Section */}
          <div className="space-y-4">
            <div className="mb-6">
              <GrantaEarthLogo 
                size="xl" 
                variant="white" 
                className="mb-4" 
              />
            </div>
            <p className="text-white/80 leading-relaxed">
              Connecting Africa's abundant natural resources with global markets through reliable partnerships in mining, energy, and commodities trading.
            </p>
            <p className="text-white/70 text-sm">
              Building sustainable economic bridges between Zimbabwe and the world.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold">Quick Links</h4>
            <nav>
              <ul className="space-y-3">
                <li>
                  <Link 
                    to="/" 
                    className="text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:text-white"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/about" 
                    className="text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:text-white"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/units/mining" 
                    className="text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:text-white"
                  >
                    Mining Division
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/units/energy" 
                    className="text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:text-white"
                  >
                    Energy Solutions
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/units/commodities" 
                    className="text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:text-white"
                  >
                    Commodities Trading
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/partnerships" 
                    className="text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:text-white"
                  >
                    Partnerships
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/contact" 
                    className="text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:text-white"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold">Contact Information</h4>
            <div className="space-y-3">
              <div>
                <p className="text-white/70 text-sm uppercase tracking-wide mb-1">Email</p>
                <a 
                  href="mailto:info@grantaearth.com" 
                  className="text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:text-white"
                >
                  info@grantaearth.com
                </a>
              </div>
              <div>
                <p className="text-white/70 text-sm uppercase tracking-wide mb-1">Phone</p>
                <a 
                  href="tel:+263719263479" 
                  className="text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:text-white"
                >
                  +263719263479
                </a>
              </div>
              <div>
                <p className="text-white/70 text-sm uppercase tracking-wide mb-1">Address</p>
                <p className="text-white/80">
                  Harare Business District<br />
                  Harare, Zimbabwe
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Copyright Bar */}
      <div className="border-t border-white/20">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <p className="text-white/70 text-sm">
              © {new Date().getFullYear()} GrantaEarth Co. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a 
                href="#" 
                className="text-white/70 hover:text-white transition-colors duration-200 focus:outline-none focus:text-white"
              >
                Privacy Policy
              </a>
              <a 
                href="#" 
                className="text-white/70 hover:text-white transition-colors duration-200 focus:outline-none focus:text-white"
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}